import React, { useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { useTheme } from 'styled-components'
import { BusinessTypeFilter as BusinessTypeFilterController, useLanguage } from '~components'

import { Tabs, Tab } from '../../styles/Tabs'
import { TypeContainer, ImageContainer } from './styles'
import { AutoScroll } from '../AutoScroll'

const BusinessTypesUI = (props) => {
  const {
    typesState,
    currentTypeSelected,
    handleChangeBusinessType
  } = props
  const { loading, error, types } = typesState
  const [, t] = useLanguage()
  const theme = useTheme()
  const [load, setLoad] = useState(false)

  const defaultImage = (name) => theme.images?.categories?.[name.toLowerCase()]

  const handleChangeCategory = (category) => {
    handleChangeBusinessType && handleChangeBusinessType(category)
  }

  return (
    <>
      <TypeContainer id='container'>
        {loading && (
          <Tabs variant='primary' disableBackground>
            <AutoScroll>
              <Tab className='category' style={styles.wrapperSkeleton}>
                {[...Array(4)].map((_, i) => (
                  <Skeleton id='skeleton' key={i} circle={true} height={54} width={54} />
                ))}
              </Tab>
            </AutoScroll>
          </Tabs>
        )}
        {!loading && !error && types && types.length > 0 && (
          <Tabs variant='primary' disableBackground>
            <AutoScroll>
              {types.map((type, i) => type.enabled && (
                <Tab
                  key={type.id}
                  active={type.id === currentTypeSelected}
                  className='category'
                  onClick={() => handleChangeCategory(type.id)}
                >
                  {type.name !== 'All' && (
                    <ImageContainer
                      active={type.id === currentTypeSelected}
                      load={load}
                    >
                      <img
                        src={type.image || (defaultImage(type.name) ?? theme.images.categories.all)}
                        alt={type.name.toLowerCase()}
                        onLoad={() => setLoad(true)}
                        width='150px'
                        height='150px'
                        loading='lazy'
                      />
                    </ImageContainer>
                  )}
                  <span className='category-name'>{t(`BUSINESS_TYPE_${type.name.replace(/\s/g, '_').toUpperCase()}`, type.name)}</span>
                </Tab>
              ))}
            </AutoScroll>
          </Tabs>
        )}
      </TypeContainer>
    </>
  )
}

const styles = {
  wrapperSkeleton: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
  }
}

export const BusinessTypes = (props) => {
  const businessTypeFilterProps = {
    ...props,
    UIComponent: BusinessTypesUI,
    defaultBusinessType: props.defaultBusinessType || null,
    onChangeBusinessType: props.handleChangeBusinessType
  }

  return (
    <BusinessTypeFilterController {...businessTypeFilterProps} />
  )
}
